import type { ComboboxProps } from '@ibsys/kit';
import { useMemo } from 'react';
import { useServerSearch } from './useServerSearch';

/**
 * Строка поиска поля выбора `Combobox`, которое набирает варианты запросом на сервер.
 *
 * Закрываясь, поле стирает набранную строку и не сообщает об этом через `onSearch`, поэтому
 * строка запроса сбрасывается тем же закрытием списка. Иначе закрытое поле — и открытое заново
 * с пустой строкой — показывает выдачу и подпись о неполноте по прежней строке.
 *
 * Возвращает `search` — строку для запроса, без краевых пробелов и с задержкой на время набора,
 * и `searchProps` — пропсы поля, которые её ведут.
 */
export const useComboboxServerSearch = () => {
  const { onChange, applied } = useServerSearch();

  const searchProps = useMemo<Pick<ComboboxProps, 'onSearch' | 'menu'>>(
    () => ({ onSearch: onChange, menu: { onCloseAutoFocus: () => onChange('') } }),
    [onChange],
  );

  return { search: applied, searchProps };
};
